import { Link as RemixLink } from 'react-router'
import { useTranslation } from 'react-i18next'
import { Icon } from '../icon/icon'
import { Link } from '~/components/internal-link/Internal-link'
import Text from '~/components/text/text'
import { getImgSrc } from '~/utils/image'
import type { EventBase } from '~/types/event'
interface EventOrganiserBlockProps {
	event: EventBase
}
export default function EventOrganiserBlock({
	event,
}: EventOrganiserBlockProps) {
	const { t } = useTranslation()
	if (
		!(
			event.ownerAsOrganizer ||
			event.organizerName ||
			event.organizerEmail ||
			event.organizerPhone ||
			event.organizerWebsite
		)
	) {
		return undefined
	}

	const name = event.ownerAsOrganizer ? event.owner.name : event.organizerName
	const email = event.ownerAsOrganizer
		? event.owner.email
		: event.organizerEmail
	const phone = event.ownerAsOrganizer
		? event.owner.phonenumber
		: event.organizerPhone
	const website = event.ownerAsOrganizer
		? event.owner.website
		: event.organizerWebsite
	const address = event.ownerAsOrganizer ? event.owner.address : undefined

	return (
		<section className="col-span-12 mb-8 mt-8 md:mb-10">
			<Text as="h3">{t('misc_contactinfo')}</Text>
			<div className="flex w-full items-center justify-between gap-6 rounded-xl border border-border bg-card px-8 py-6 text-center shadow-sm max-md:flex-col-reverse md:text-left">
				<div>
					{name && (
						<Text className="flex items-center py-2">
							<Icon name="avatar" className="mr-2 text-xl" />
							{name}
						</Text>
					)}
					{phone && (
						<Text className="flex items-center py-2">
							<Icon name="phone" className="mr-2 text-xl" />
							<RemixLink
								to={`tel:${phone}`}
								className="text-secondary underline"
							>
								{phone}
							</RemixLink>
						</Text>
					)}
					{email && (
						<Text className="flex items-center py-2">
							<Icon name="envelope" className="mr-2 text-xl" />
							<RemixLink
								to={`mailto:${email}`}
								className="text-secondary underline"
							>
								{email}
							</RemixLink>
						</Text>
					)}
					{website && (
						<Text className="flex items-center py-2">
							<Icon name="globe" className="mr-2 text-xl" />
							<RemixLink
								to={`${website}`}
								target="_blank"
								rel="noreferrer"
								className="text-secondary underline"
							>
								{t('misc_website')}
							</RemixLink>
						</Text>
					)}
					{address && (
						<Text className="flex items-center py-2">
							<Icon name="position-marker" className="mr-2 text-xl" />
							<a
								href={`https://maps.google.com/?q=${address}`}
								target="_blank"
								rel="noreferrer"
								className="text-secondary underline"
							>
								{t('misc_address')}
							</a>
						</Text>
					)}
				</div>
				{event.ownerAsOrganizer && (
					<>
						{event.owner.isAdmin ? (
							<img
								src={getImgSrc(event.owner.imageId, 'user')}
								alt={event.owner.name ?? ''}
								className="h-32 w-32 rounded-full object-cover"
								loading="lazy"
							/>
						) : (
							<Link to={`/users/${event.owner.id}`}>
								<img
									src={getImgSrc(event.owner.imageId, 'user')}
									alt={event.owner.name ?? ''}
									className="h-32 w-32 rounded-full object-cover"
									loading="lazy"
								/>
							</Link>
						)}
					</>
				)}
			</div>
		</section>
	)
}
